import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./BulkNotificatio.module.css";
// import companyStore from "../../../../Store/Store";

const Notificatio = ({
  completeData,
  incompleteData,
  isVisible,
  duplicateUsers,
  onClose,
  className = "",
}) => {
  const navigate = useNavigate();

  const onXCircleIconClick = useCallback(() => {
    navigate("/payout");
  }, [navigate]);

  // if(!isVisible) return null
  return (
    <div className={[styles.frameParent, className].join(" ")}>
      <div className={styles.containerNotifi}>
        <div className={styles.httpslottiefilescomanimatParent}>
          <div className={styles.httpslottiefilescontent}>
            <div className={styles.httpslottiefilescontent1}>
              {"12"}
              <img
                className={styles.plusCircleIconHeading}
                alt=""
                src="/check-circle.svg"
              />
            </div>
            <div className={styles.plusCircleIcontext}>
              Payout successfully sent for approval
            </div>
          </div>
          {true && (
            <div className={styles.httpslottiefilescontent}>
              <div className={styles.httpslottiefilescontent1}>
                {"0"}
                <img
                  className={styles.plusCircleIconHeading}
                  alt=""
                  src="/x-circle.svg"
                />
              </div>
              <div className={styles.plusCircleIcontext}>
                Payout skipped as they are invalid
              </div>
            </div>
          )}
        </div>
        <button
          className={styles.userAddedSuccessfullyBtn}
          onClick={() => {
            onXCircleIconClick();
          }}
        >
          Return to Payout
        </button>
      </div>
    </div>
  );
};

Notificatio.propTypes = {
  className: PropTypes.string,
};

export default Notificatio;
